import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
import { useContentObjectContext } from "../contexts/ContentObjectContext";
// const querystring = require("querystring");

const ManageContentTypes = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [contentTypes, setContentTypes] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const navigate = useNavigate();
  const { currentContentObject } = useContentObjectContext();
  const [state, setState] = useState({
    contentTypeId: parseInt(parms.get("id")),
    contentId: currentContentObject,
    contentTypeValueCode: 0,
    contentTypeName: "",
    contentTypeDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-types/${state.contentTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentTypeId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentTypes = res.data;
        console.log(contentTypes);
        setContentTypes(contentTypes);
      });

    console.log("handleOnLoad() - loading id = " + state.contentTypeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-types/${state.contentTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };


  function onDelete() {
    let deleteID = state.contentTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate(-1);
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
        <h4>Manage Content Type</h4>
        <hr></hr>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="content_id"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <h4>Content Type Details</h4>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Select Content Type">
            Select Content Type
          </label>
          <select
            className="form-control input-xlarge col-sm-8"
            id="contentTypeId"
            onchange="submit()"
            immediate="true"
            value="#{ombContentTypeForm.currentContentType.contentTypeId}"
            valueChangeListener="#{ombContentTypeForm.get }"
          >
            <option value="#{ombContentTypeForm.contentTypeSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Content Type Name</label>
          <input
            id="contentTypeName"
            className="form-control input-medium col-sm-8"
            value={state.contentTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Content Type Code</label>
          <select
            className="form-control input-xlarge col-sm-8"
            id="contentTypeValueCode"
            value={state.contentTypeValueCode}
            onChange={handleChange}
          >
            <option value={0}>Select Content Type</option>
            {contentTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">
            Content Type Description
          </label>
          <textarea
            id="contentTypeDescr"
            className="form-control input-big col-sm-8"
            value={state.contentTypeDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />

        <button
          className="btn btn-danger"
          value="Delete"
         onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Save"
          onClick={handleSave}
        >
          {" "}
          Save
        </button>
        &nbsp;

      </div>
    </form>
  );
};

export default ManageContentTypes;
